// Libs
import React, { useContext } from "react";
import styled from "styled-components";
import { DropdownContext } from "../Dropdown";

const DropdownItem = ({ children, onClick, checked, setActive, props }) => {
  const { closeDropdown } = useContext(DropdownContext);
  return (
    <ButtonNoStyle
      checked={checked}
      onClick={() => {
        onClick();
        closeDropdown && closeDropdown();
      }}
    >
      {children}
    </ButtonNoStyle>
  );
};

const ButtonNoStyle = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  border-radius: 4px;
  background-color: ${props => (props.checked ? "#f4f5f8" : "white")};
  padding: 4px 8px;
  width: 100%;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.14;
  color: #222939;
  margin-bottom: 8px;
  :hover {
    background-color: #f4f5f8;
  }
`;

export default DropdownItem;
